import { defineStore } from 'pinia'
import UserService from "@/services/user.service.ts";
export const useUserStore = defineStore('user', {
    state: () => {
        return {
            users: [],
            user: {}
        }
    },
    persist: true,
    actions: {
        async getListUser(url, params) {
            try {
                const users = await UserService.getListUsers(url, params)
                this.users = users.data
            } catch (e) {
                return null
            }
        },
    }
})
